import axios from 'axios';
import { API_ENDPOINTS } from '../api-urls';

// Get all active products
export const getAllProducts = async () => {
  try {
    const response = await axios.get(API_ENDPOINTS.getAllProducts);
    return response.data;
  } catch (error) {
    console.error("Error fetching all active products:", error);
    throw error;
  }
};

export const getProductById = async (productId) => {
  try {
    const response = await axios.get(`${API_ENDPOINTS.getProductById}${productId}`);
    return response.data;
  } catch (error) {
    console.error(`Error fetching product with ID ${productId}:`, error);
    throw error;
  }
};


// Get products for a specific category
export const getProductsByCategory = async (categoryId) => {
  try {
    const response = await axios.get(`${API_ENDPOINTS.getAllProductsInCategory}${categoryId}`);
    return response.data;
  } catch (error) {
    console.error(`Error fetching products for category ${categoryId}:`, error);
    throw error;
  }
};

